import type { TimeEvent } from "../../band-data/types";
import { toBandRows } from "./build-band-options";

/** Time covered by the events inside the window. A running event counts up to now. */
export function totalMs(events: TimeEvent[], window: { startMs: number; endMs: number }, nowMs: number): number {
    return toBandRows(events, window, nowMs).reduce((sum, [startMs, endMs]) => sum + endMs - startMs, 0);
}
